import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Spacer } from "../../styles/CommonElements";
import Button from "../Button";
import { APP_LOGO, APP_NAME, SESSION_STORAGE } from "../../helpers/constants";
import { device, useBreakpoints } from "../../lib/breakpoints";

export default function NewUserCarousel() {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoints();

  return (
    <Container>
      <TopSection>
        <Logo src={APP_LOGO} alt="" />
      </TopSection>

      <InnerContainer>
        <HeaderContainer>
          <Header>Welcome to {APP_NAME}!</Header>
          <Subheader>
            Get your rent roll, messages, and maintenance workflow organized in
            one place, built for independent landlords, not corporate sprawl.{" "}
          </Subheader>
        </HeaderContainer>

        <Spacer $marginTop="1.5rem" />

        <ButtonSection>
          <Spacer $marginTop="32px" />

          <Button
            size="large"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              navigate("/use", { replace: true });
            }}
          >
            Get Started
          </Button>
        </ButtonSection>

        {isMobile && <Spacer $marginTop="1rem" />}
      </InnerContainer>
    </Container>
  );
}

const Container = styled.div`
  @media ${device.mobile} {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;

const InnerContainer = styled.div`
  height: auto;
  width: 100%;
  margin-top: 1rem;

  .slick-dots {
    li {
      width: 8px;
      height: 8px;
      border-radius: 100px;
      background: #35383f;
    }

    .slick-active {
      width: 32px;
      height: 8px;
      border: 0;
      background: linear-gradient(286deg, #525cf5 0%, #f49090 100%);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }

    button {
      opacity: 0 !important;
    }
  }
`;

const ButtonSection = styled.div`
  margin: auto;

  @media ${device.mobile} {
    width: 90%;
  }
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 24px;
  opacity: initial;
  pointer-events: auto;
`;

const HeaderContainer = styled.div`
  margin: auto;
  width: 90%;
`;

const Header = styled.div`
  color: black;
  text-align: center;
  font-family: var(--font-primary);
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  margin-top: 10px;
`;

const Subheader = styled.div`
  color: var(--color-gray-100);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.2px;
  margin: 8px;
`;

const Logo = styled.img`
  height: 54px;
  width: auto;
  margin: auto;
`;
